import { Routes } from '@angular/router';
import { adminGuard } from '../../core/guards';
import { CATALOGUE_CONFIG } from '../catalogue/catalogue.types';
import { WEAPON_CATALOGUE } from './weapon.config';

export const weaponsRoutes: Routes = [
  {
    path: 'weapons',
    providers: [{ provide: CATALOGUE_CONFIG, useValue: WEAPON_CATALOGUE }],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('../catalogue/catalogue-list/catalogue-list.component').then((m) => m.CatalogueListComponent),
      },
      {
        path: 'new',
        loadComponent: () =>
          import('./components/weapon-create/weapon-create.component').then((m) => m.WeaponCreateComponent),
        canActivate: [adminGuard],
      },
      {
        path: ':id',
        loadComponent: () =>
          import('../catalogue/catalogue-detail/catalogue-detail.component').then((m) => m.CatalogueDetailComponent),
      },
      {
        path: ':id/edit',
        loadComponent: () =>
          import('./components/weapon-edit/weapon-edit.component').then((m) => m.WeaponEditComponent),
        canActivate: [adminGuard],
      },
    ],
  },
  {
    path: 'weapon-manufacturers',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./components/manufacturer-list/weapon-manufacturer-list.component').then(
            (m) => m.WeaponManufacturerListComponent,
          ),
      },
      {
        path: 'new',
        loadComponent: () =>
          import('./components/manufacturer-create/weapon-manufacturer-create.component').then(
            (m) => m.WeaponManufacturerCreateComponent,
          ),
        canActivate: [adminGuard],
      },
      {
        path: ':id/edit',
        loadComponent: () =>
          import('./components/manufacturer-edit/weapon-manufacturer-edit.component').then(
            (m) => m.WeaponManufacturerEditComponent,
          ),
        canActivate: [adminGuard],
      },
    ],
  },
];
